// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file catalogos_terceros.proto (package sextante.catalogos.terceros.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file catalogos_terceros.proto.
 */
export const file_catalogos_terceros: GenFile = /*@__PURE__*/
  fileDesc("ChhjYXRhbG9nb3NfdGVyY2Vyb3MucHJvdG8SHnNleHRhbnRlLmNhdGFsb2dvcy50ZXJjZXJvcy52MSJaChBEZXBhcnRhbWVudG9JdGVtEgoKAmlkGAEgASgJEhEKCWVsaW1pbmFkbxgCIAEoCBIOCgZub21icmUYBCABKAkSFwoPYXJlYV9nZW9ncmFmaWNhGAUgASgMIjkKGExpc3REZXBhcnRhbWVudG9zUmVxdWVzdBIdChV1bHRpbWFfc2luY3Jvbml6YWNpb24YASABKAMifgoZTGlzdERlcGFydGFtZW50b3NSZXNwb25zZRI/CgVpdGVtcxgBIAMoCzIwLnNleHRhbnRlLmNhdGFsb2dvcy50ZXJjZXJvcy52MS5EZXBhcnRhbWVudG9JdGVtEiAKGHRpbWVzdGFtcF9zaW5jcm9uaXphY2lvbhgCIAEoAyJwCg1NdW5pY2lwaW9JdGVtEgoKAmlkGAEgASgJEhEKCWVsaW1pbmFkbxgCIAEoCBIXCg9kZXBhcnRhbWVudG9faWQYBCABKAkSDgoGbm9tYnJlGAUgASgJEhcKD2FyZWFfZ2VvZ3JhZmljYRgGIAEoDCJACiVMaXN0TXVuaWNpcGlvc0J5RGVwYXJ0YW1lbnRvSWRSZXF1ZXN0EhcKD2RlcGFydGFtZW50b19pZBgBIAEoCSJWChZMaXN0TXVuaWNpcGlvc1Jlc3BvbnNlEjwKBWl0ZW1zGAEgAygLMi0uc2V4dGFudGUuY2F0YWxvZ29zLnRlcmNlcm9zLnYxLk11bmljaXBpb0l0ZW0yxwIKGENhdGFsb2dvc1RlcmNlcm9zU2VydmljZRKIAQoRTGlzdERlcGFydGFtZW50b3MSOC5zZXh0YW50ZS5jYXRhbG9nb3MudGVyY2Vyb3MudjEuTGlzdERlcGFydGFtZW50b3NSZXF1ZXN0Gjkuc2V4dGFudGUuY2F0YWxvZ29zLnRlcmNlcm9zLnYxLkxpc3REZXBhcnRhbWVudG9zUmVzcG9uc2USnwEKHkxpc3RNdW5pY2lwaW9zQnlEZXBhcnRhbWVudG9JZBJFLnNleHRhbnRlLmNhdGFsb2dvcy50ZXJjZXJvcy52MS5MaXN0TXVuaWNpcGlvc0J5RGVwYXJ0YW1lbnRvSWRSZXF1ZXN0GjYuc2V4dGFudGUuY2F0YWxvZ29zLnRlcmNlcm9zLnYxLkxpc3RNdW5pY2lwaW9zUmVzcG9uc2VCC6oCCEFwaS5HcnBjYgZwcm90bzM");

/**
 * Departamento del catalogo DANE.
 *
 * @generated from message sextante.catalogos.terceros.v1.DepartamentoItem
 */
export type DepartamentoItem = Message<"sextante.catalogos.terceros.v1.DepartamentoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja en el catalogo: la app lo quita de su copia local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * @generated from field: string nombre = 4;
   */
  nombre: string;

  /**
   * WKB MultiPolygon, SIN simplificar: el limite dibujado tiene que coincidir con el que usa la
   * asignacion de municipio del predio (ver CatalogosTercerosGrpcService).
   *
   * @generated from field: bytes area_geografica = 5;
   */
  areaGeografica: Uint8Array;
};

/**
 * Describes the message sextante.catalogos.terceros.v1.DepartamentoItem.
 * Use `create(DepartamentoItemSchema)` to create a new message.
 */
export const DepartamentoItemSchema: GenMessage<DepartamentoItem> = /*@__PURE__*/
  messageDesc(file_catalogos_terceros, 0);

/**
 * Pedido del catalogo de departamentos.
 *
 * @generated from message sextante.catalogos.terceros.v1.ListDepartamentosRequest
 */
export type ListDepartamentosRequest = Message<"sextante.catalogos.terceros.v1.ListDepartamentosRequest"> & {
  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 1;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.terceros.v1.ListDepartamentosRequest.
 * Use `create(ListDepartamentosRequestSchema)` to create a new message.
 */
export const ListDepartamentosRequestSchema: GenMessage<ListDepartamentosRequest> = /*@__PURE__*/
  messageDesc(file_catalogos_terceros, 1);

/**
 * Departamentos que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.catalogos.terceros.v1.ListDepartamentosResponse
 */
export type ListDepartamentosResponse = Message<"sextante.catalogos.terceros.v1.ListDepartamentosResponse"> & {
  /**
   * @generated from field: repeated sextante.catalogos.terceros.v1.DepartamentoItem items = 1;
   */
  items: DepartamentoItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.terceros.v1.ListDepartamentosResponse.
 * Use `create(ListDepartamentosResponseSchema)` to create a new message.
 */
export const ListDepartamentosResponseSchema: GenMessage<ListDepartamentosResponse> = /*@__PURE__*/
  messageDesc(file_catalogos_terceros, 2);

/**
 * Municipio de un departamento.
 *
 * @generated from message sextante.catalogos.terceros.v1.MunicipioItem
 */
export type MunicipioItem = Message<"sextante.catalogos.terceros.v1.MunicipioItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja en el catalogo: la app lo quita de su copia local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * @generated from field: string departamento_id = 4;
   */
  departamentoId: string;

  /**
   * @generated from field: string nombre = 5;
   */
  nombre: string;

  /**
   * WKB MultiPolygon, SIN simplificar (ver CatalogosTercerosGrpcService).
   *
   * @generated from field: bytes area_geografica = 6;
   */
  areaGeografica: Uint8Array;
};

/**
 * Describes the message sextante.catalogos.terceros.v1.MunicipioItem.
 * Use `create(MunicipioItemSchema)` to create a new message.
 */
export const MunicipioItemSchema: GenMessage<MunicipioItem> = /*@__PURE__*/
  messageDesc(file_catalogos_terceros, 3);

/**
 * Departamento del que se piden los municipios.
 *
 * @generated from message sextante.catalogos.terceros.v1.ListMunicipiosByDepartamentoIdRequest
 */
export type ListMunicipiosByDepartamentoIdRequest = Message<"sextante.catalogos.terceros.v1.ListMunicipiosByDepartamentoIdRequest"> & {
  /**
   * @generated from field: string departamento_id = 1;
   */
  departamentoId: string;
};

/**
 * Describes the message sextante.catalogos.terceros.v1.ListMunicipiosByDepartamentoIdRequest.
 * Use `create(ListMunicipiosByDepartamentoIdRequestSchema)` to create a new message.
 */
export const ListMunicipiosByDepartamentoIdRequestSchema: GenMessage<ListMunicipiosByDepartamentoIdRequest> = /*@__PURE__*/
  messageDesc(file_catalogos_terceros, 4);

/**
 * Municipios del departamento pedido.
 *
 * @generated from message sextante.catalogos.terceros.v1.ListMunicipiosResponse
 */
export type ListMunicipiosResponse = Message<"sextante.catalogos.terceros.v1.ListMunicipiosResponse"> & {
  /**
   * @generated from field: repeated sextante.catalogos.terceros.v1.MunicipioItem items = 1;
   */
  items: MunicipioItem[];
};

/**
 * Describes the message sextante.catalogos.terceros.v1.ListMunicipiosResponse.
 * Use `create(ListMunicipiosResponseSchema)` to create a new message.
 */
export const ListMunicipiosResponseSchema: GenMessage<ListMunicipiosResponse> = /*@__PURE__*/
  messageDesc(file_catalogos_terceros, 5);

/**
 * Migracion a gRPC-Web de los catalogos administrativos DANE (Departamento/Municipio,
 * ver CLAUDE.md, seccion migracion a gRPC-Web). Geometrias en WKB (bytes), no GeoJSON -mismo
 * criterio que login.proto y terceros_finca_wizard.proto-. El cliente decodifica con wkbUtils.ts
 * (wkbToMultiPolygon). No exponen "ultima_actualizacion" -ver catalogos_aplicaciones.proto-.
 *
 * DepartamentoRegion (ListDepartamentoRegionesByDepartamentoId) se elimino (2026-09-22): el wizard
 * de finca paso a filtrar por Municipio y era su unico consumidor. Mismo criterio con el que se
 * habia eliminado antes ListMunicipios (2026-09-15), que vuelve aca con consumidor real.
 *
 * Municipio se pide por departamento_id en vez de traer los ~1122 del pais de una: AoiMapRender solo
 * dibuja los del departamento que el usuario ya eligio, nunca todos a la vez, asi que no tiene
 * sentido pagar ese peso por adelantado (medido: ~75 MB sin simplificar). No tiene watermark: es una
 * consulta puntual, no un catalogo que se sincroniza una vez y persiste.
 *
 * @generated from service sextante.catalogos.terceros.v1.CatalogosTercerosService
 */
export const CatalogosTercerosService: GenService<{
  /**
   * Departamentos de Colombia con su contorno, por delta.
   *
   * @generated from rpc sextante.catalogos.terceros.v1.CatalogosTercerosService.ListDepartamentos
   */
  listDepartamentos: {
    methodKind: "unary";
    input: typeof ListDepartamentosRequestSchema;
    output: typeof ListDepartamentosResponseSchema;
  },
  /**
   * Municipios de un departamento con su contorno. Sin delta: se piden cuando el usuario elige el departamento.
   *
   * @generated from rpc sextante.catalogos.terceros.v1.CatalogosTercerosService.ListMunicipiosByDepartamentoId
   */
  listMunicipiosByDepartamentoId: {
    methodKind: "unary";
    input: typeof ListMunicipiosByDepartamentoIdRequestSchema;
    output: typeof ListMunicipiosResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_catalogos_terceros, 0);

